export const STORE_ORDER_CONTAINER_STEP = 'STORE_ORDER_CONTAINER_STEP';

export function storeOrderContainerStep(step) {
  return {
    type: STORE_ORDER_CONTAINER_STEP,
    payload: step,
  };
}
